// import Procedure from './Procedure';

export default {
  priority: 96,
  path: "procedure",
  permissions: ["RequestsMenu/WorkflowMenu"], // ['WorkflowMenu'],
  icon: "message-processing",
  // component: Procedure,
  component: load(() =>
    import(/* webpackChunkName: "Requests-Procedure" */ "./Search")
  ),
  name: app.translate("جستجوی افراد در روند"),
  drawer: true,
};
